import { render, staticRenderFns } from "./HealthEdit.vue?vue&type=template&id=e66cf418&scoped=true&"
import script from "./HealthEdit.vue?vue&type=script&lang=js&"
export * from "./HealthEdit.vue?vue&type=script&lang=js&"
import style0 from "./HealthEdit.vue?vue&type=style&index=0&id=e66cf418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66cf418",
  null
  
)

component.options.__file = "HealthEdit.vue"
export default component.exports